import { useContext } from 'react';
import { XeroContext } from '@/context/XeroProvider';

const useXero = () => {
  return useContext(XeroContext);
};

export default useXero;
